import { render, staticRenderFns } from "./RenewPopup.vue?vue&type=template&id=0dbd610d&scoped=true&"
import script from "./RenewPopup.vue?vue&type=script&lang=js&"
export * from "./RenewPopup.vue?vue&type=script&lang=js&"
import style0 from "./RenewPopup.vue?vue&type=style&index=0&id=0dbd610d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd610d",
  null
  
)

export default component.exports